import { URL_PAYMENT_CONFIG, URL_PAYMENT_PRICES } from "../Utils/Strings/URL"
import * as actionType from "./Action_Type";
export const paymentConfig_request = () => ({
    type            : actionType.SERVICE_PAYMENT_CONFIG_REQUEST,
    isFetching      : true
});
export const paymentConfig_success = (config) => ({
    type            : actionType.SERVICE_PAYMENT_CONFIG_SUCCESS,
    isFetching      : false,
    config
});
export const paymentConfig_error = (msgError) => ({
    type            : actionType.SERVICE_PAYMENT_CONFIG_ERROR,
    isFetching      : false,
    msgError
});
export function paymentConfig(){
    let config = {
        method  : 'GET',
        headers : { 'Content-Type': 'application/json' },
    };
    return dispatch => {
      dispatch(paymentConfig_request());

      return fetch(URL_PAYMENT_CONFIG, config)
        .then(response =>
          response.json().then(p_config => ({ p_config, response }))
        )
        .then(({ p_config, response }) => {
          if (!response.ok) {
            return Promise.reject(p_config);
          } else {
            dispatch(paymentConfig_success(p_config.Data));
          }
        })
        .catch(err => {
            console.error(err.Message);
            dispatch(paymentConfig_error(err.Message));
          }
        );
    };
};

export const paymentPrices_request = () => ({
    type            : actionType.SERVICE_PAYMENT_PRICES_REQUEST,
    isFetching      : true
});
export const paymentPrices_success = (prices) => ({
    type            : actionType.SERVICE_PAYMENT_PRICES_SUCCESS,
    isFetching      : false,
    prices
});
export const paymentPrices_error = (msgError) => ({
    type            : actionType.SERVICE_PAYMENT_PRICES_ERROR,
    isFetching      : false,
    msgError
});
export function paymentPrices(){
    let config = {
        method  : 'GET',
        headers : { 'Content-Type': 'application/json' },
    };
    return dispatch => {
      dispatch(paymentPrices_request());

      return fetch(URL_PAYMENT_PRICES, config)
        .then(response =>
          response.json().then(p_prices => ({ p_prices, response }))
        )
        .then(({ p_prices, response }) => {
          if (p_prices.Code != 200) {
            return Promise.reject(p_prices);
          } else {
            dispatch(paymentPrices_success(p_prices.Data));
          }
        })
        .catch(err => {
            console.error(err.Message);
            dispatch(paymentPrices_error(err.Message));
          }
        );
    };
};


// WEBPACK FOOTER //
// ./src/Actions/Action_ServiceRequest_Pagamento.js